import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.css';
import './styles/layout.css';
import './pages/home/styles/shared.css';
import './pages/home/styles/hero.css';
import './pages/home/styles/about.css';
import './pages/home/styles/products.css';
import './pages/home/styles/openSource.css';
import './pages/home/styles/services.css';
import './pages/home/styles/docs.css';
import './pages/home/styles/community.css';
import './pages/home/styles/brandStrip.css';
import './pages/home/styles/contact.css';
import './pages/home/styles/teamMap.css';
import './pages/home/styles/responsive.css';
import './pages/modules/modules.css';
import App from './app/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
